module.exports = __webpack_public_path__ + "img/jifenrenwu_yaoqingguanzhudianpu.daba638e.png";